<template>
  <aside v-clickaway.detectIframe="closeNotiBar" class="bg-light-gray-400 border-radius noti-center notification__center" :class="{ active: notiBar.isOpen }">
    <NewNotificationCenter />
  </aside>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import getLocale from "@/mixins/getLocale.js";
import checkGlobalConfigs from "@/mixins/checkGlobalConfigs";
import NewNotificationCenter from "./NewNotificationCenter/index.vue";

export default {
  name: "NotiCenter",
  components: {
    NewNotificationCenter
  },
  filters: {
    formatAMPM(value) {
      let date = new Date(value);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    }
  },
  mixins: [getLocale, checkGlobalConfigs()],
  props: {
    isOpenNoti: Boolean
  },
  data() {
    return {
      delayTimer: undefined,
      totalLoaded: 0,
      settings: {
        handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
        wheelPropagation: true,
        wheelSpeed: 0.6
      },
      marking: false
    };
  },
  computed: {
    ...mapGetters("notibar", {
      notiBar: "notiBar",
      notiList: "noti",
      pinnedNotiList: "pinnedNoti",
      isLoadingNoti: "isLoadingNoti",
      isLoadingMoreNoti: "isLoadingMoreNoti",
      last_system_noti: "last_system_noti",
      noti_list_count: "noti_list_count",
      limit_pagination: "limit_pagination",
      notiAction: "noti_action"
    }),
    ...mapState("notibar", {
      maxAllReaded: state => state.notiBar.maxAllReaded
    }),
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    isDevStore() {
      return this.shopInfo.developmentStore;
    },
    listPinnedNoti() {
      return this.pinnedNotiList.filter(e => {
        if (e.settings?.data) {
          try {
            const settingsJSON = JSON.parse(this.noti.settings.data);

            if (Object.keys(settingsJSON).length == 0) {
              return true;
            }

            if (settingsJSON["free"] && this.isDevStore) {
              return true;
            }

            if (settingsJSON[this.shopInfo.plan]) {
              return true;
            }

            return false;
          } catch (err) {
            // eslint-disable-next-line no-console
            console.warn({
              err,
              json: this.noti.settings.data
            });
          }
        }
        return true;
      });
    },
    listNoti() {
      return this.notiList.filter(e => {
        if (e.settings?.data) {
          try {
            const settingsJSON = JSON.parse(this.noti.settings.data);

            if (Object.keys(settingsJSON).length == 0) {
              return true;
            }

            if (settingsJSON["free"] && this.isDevStore) {
              return true;
            }

            if (settingsJSON[this.shopInfo.plan]) {
              return true;
            }

            return false;
          } catch (err) {
            // eslint-disable-next-line no-console
            console.warn({
              err,
              json: this.noti.settings.data
            });
          }
        }
        return true;
      });
    },
    loadedAll() {
      return this.totalLoaded >= this.noti_list_count;
    },
    noti() {
      if (this.last_system_noti && this.last_system_noti[0]) {
        return this.last_system_noti[0];
      }
      return undefined;
    },
    notiTitle() {
      return this.getLocaleText(this.notiAction.noti.title);
    },
    notiContent() {
      return this.getLocaleText(this.notiAction.noti.content);
    }
  },
  watch: {
    "$route.path"() {
      this.closeNotiCenter();
    }
  },
  methods: {
    ...mapActions("notibar", {
      showNotificationBar: "showNotificationBar",
      closeNotiCenter: "closeNotificationBar",
      closeNotiBar: "closeNotificationBar",
      loadNoti: "loadNoti",
      loadMoreNoti: "loadMoreNoti",
      showModalNoti: "showModalNoti",
      trackAction: "trackAction",
      closeNotiContent: "closeNotiContent",
      markAllAsRead: "markAllAsRead"
    }),
    ...mapActions("tutorial", {
      openStartedGuide: "openStartedGuide"
    }),
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.letLoadMore();
      }
    },
    letLoadMore() {
      clearTimeout(this.delayTimer);
      if (this.loadedAll) {
        return;
      }
      if (this.isLoadingMoreNoti) {
        return;
      }
      let loaded = this.totalLoaded;
      this.delayTimer = setTimeout(() => {
        this.loadMoreNoti({
          loaded,
          onSuccess: () => {
            this.totalLoaded += this.limit_pagination;
          },
          onError: err => {
            this.gSnackbarCommit({
              message: typeof err == "object" ? err.toString() : err,
              type: "error"
            });
          }
        });
      }, 500);
    },
    markRead() {
      if (this.maxAllReaded == true || this.marking == true) {
        return;
      }
      this.markAllAsRead({
        onLoading: () => {
          this.marking = true;
          this.gSnackbarCommit({
            message: this.$t("status.processing"),
            type: "loading"
          });
        },
        onSuccess: () => {
          this.gSnackbarCommit({
            message: this.$t("notifications.markReadSuccess"),
            type: "success"
          });
          this.marking = false;
        },
        onError: err => {
          this.gSnackbarCommit({
            message: typeof err == "object" ? err.toString() : err,
            type: "error"
          });
          this.marking = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/core/themes/partials/_tooltips.scss";
</style>

<style lang="scss" scoped>
@import "@/core/themes/partials/_utils.scss";

.active {
  // display: flex !important;
  visibility: visible !important;
  opacity: 1 !important;
  z-index: 100 !important;
  pointer-events: auto;
  transform: translateX(0%) !important;
}
.noti-center {
  .ps {
    position: relative;
    height: calc(100vh - 112px);
  }
  display: flex !important;
  visibility: none;
  opacity: 0;
  box-shadow: -18px -9px 15px -18px #aaaaaa;
  position: fixed;
  margin-top: 60px;
  right: 0;
  transform: translateX(100%);
  top: 0;
  height: 100vh;
  width: 280px;
  min-width: 280px;
  background-color: $light3;
  // display: none;
  flex-direction: column;
  transition: all 0.3s ease;
  z-index: -100;
  // pointer-events: none;
  > .title {
    background-color: $light3;
    border-bottom: 1px solid $textDarkModeHigh;
    padding: 16px;
    position: relative;
    box-sizing: border-box;
    .back-to-noti {
      cursor: pointer;
      color: $textLightModeLow;
    }
    .noti-content {
      position: absolute;
      border-top: 1px solid $textDarkModeHigh;
      width: 100%;
      height: 2000px;
      right: 0;
      top: 100%;
      transform: translateX(100%);
      z-index: 101;
      background: $light3;
      transition: all 0.3s ease;
      &-active {
        transform: translateX(0%) !important;
      }
      > a {
        padding-top: 11px !important;
        padding-bottom: 11px !important;
      }
    }
    span {
      &:first-child {
        color: $textLightModeHigh;
        margin-right: auto;
      }
      &:nth-child(2) {
        margin-left: auto;
      }
    }
  }
  .list-empty {
    padding: 32px 38px;
    span {
      color: $textLightModeDisabled;
      display: flex;
      white-space: nowrap;
    }
  }
  .noti-list {
    // overflow-y: scroll;
    // overflow-x: hidden;
    margin-bottom: 60px;
    // &-disabled{
    //   opacity: 0;
    //   pointer-events: none;
    // }
    .noti-list-show {
      .loading-more {
        position: relative;
        height: 100px;
      }
      .loading-done {
        > p {
          text-align: center;
        }
      }
    }
  }
}

.notification {
  &__center {
    box-shadow: 0px 2px 6px rgba(84, 90, 116, 0.1), 0px 6px 12px 2px rgba(84, 90, 116, 0.1);
    width: 344px;
    height: calc(100vh - 60px);
  }
}
</style>
